import React, { useState, useEffect } from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import ManagmentBanner from "../../components/managmentBanner";
import { styled, useMediaQuery } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import TabComponent from "../../components/tabComponent";
import { useLocation } from "react-router-dom";
import TabDetails from "./tabDetails/index";
import TreatmentDetailsTab from "./treatmentDetails";
import TabRegistrationMonth from "./tabRegistrationMonth";
import { formatDate } from "../../utils/dateUtils.js";
 
import {
  callApiAsync,
  getCallOpportunity,
  postUpdateOportunityUpdateDate
} from "../../services/apiService.js";
import { isActiveProcessByRole } from "./authorizeFxs.js";
import { useSelector } from "react-redux";
import { headerBannerType } from "../../constants/enums.js";
import HeaderBanner from "../../components/headerBanner/index.js";
import { isRiskVersion } from "../../utils/riskAndOportunityVersion";
import { months as monthsList } from "../../constants/selectData";
 
const getRowData = (location) => {
  const state = location?.state;
  return state?.rowData ?? state ?? {};
};

const OpportunityDetails = () => {
  const userData = useSelector((state) => state.userData.userData);
  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const location = useLocation();
  const [opportunityData, setOpportunityData] = useState([]);
  const rowData = getRowData(location);
  const [isEditionAvailable, setisEditionAvailable] = useState(false);
  const [isEditableMonthRegister, setIsEditableMonthRegister] = useState(false);

  const getOpportunityData = async () => {
    // Preferir omId (opportunity_month id) para que getOpportunity devuelva el año/mes de ese registro y aplique la versión correcta.
    const opportunityId = rowData.omId ?? rowData.id ?? "";

    if (!opportunityId) return;

    callApiAsync(
      () => getCallOpportunity(opportunityId),
      (data) => {
        setOpportunityData(data);

        const mayEditProcess = isActiveProcessByRole(
          userData.roleList,
          data.processId
        );
        setisEditionAvailable(mayEditProcess);
        setIsEditableMonthRegister(mayEditProcess);
      }
    );
  };

  const updateRiskupdateDate = async () => {
    const dataToSend = {
      opportunityId: opportunityData.id,
      userId: userData.id
    };
    await callApiAsync(
      () => postUpdateOportunityUpdateDate(dataToSend),
      () => {
        getOpportunityData();
      }
    );
  };

  useEffect(() => {
    getOpportunityData();
  }, []);

  const CustomTabPanel = styled(TabPanel)(({ theme }) => ({
    padding: "10px",
    borderTop: `0`,
    borderBottomRightRadius: "15px",
    borderBottomLeftRadius: "15px",
    fontFamily: "Lato"
  }));

  const useVersion2 = isRiskVersion(opportunityData?.year, opportunityData?.month) === 2;

  const tabData = [
    {
      name: "Detalles de la Oportunidad",
      id: "0",
      content: (
        <CustomTabPanel value="0">
          <TabDetails
            data={opportunityData}
            getOpportunityData={getOpportunityData}
            isEditionAvailable={isEditionAvailable}
            updateRiskupdateDate={updateRiskupdateDate}
          />
        </CustomTabPanel>
      )
    },
    ...(useVersion2
      ? [
          {
            name: "Detalles del Tratamiento",
            id: "1",
            content: (
              <TreatmentDetailsTab
                data={opportunityData}
                getOpportunityData={getOpportunityData}
                isEditionAvailable={isEditionAvailable}
                updateRiskupdateDate={updateRiskupdateDate}
              />
            )
          }
        ]
      : []),
    {
      name: "Registro por Mes",
      id: useVersion2 ? "2" : "1",
      content: (
        <CustomTabPanel value={useVersion2 ? "2" : "1"}>
          <TabRegistrationMonth
            dataOpportunity={opportunityData}
            getOpportunityData={getOpportunityData}
            isEditionAvailable={isEditableMonthRegister}
            updateRiskupdateDate={updateRiskupdateDate}
          />
        </CustomTabPanel>
      )
    }
  ];

  return (
    <div>
      <BreadCrumbComp personalized={`OPORTUNIDADES - ${rowData.processName}`} />
      <HeaderBanner type={headerBannerType.riskAndOportunity} />
      <div className="gm-header">
        <div className="HContainer">
          <h1 className="gm-header-title-grey" style={{ marginRight: "15px" }}>
            N°: O-{opportunityData.opportunity_key} - {opportunityData.title}
          </h1>
          <h1 className="gm-header-title"> {rowData.processName}</h1>
        </div>
        <div className="gm-header">
          <div className="j-space-between mb-10">
            <p className="lastC-text">Última Actualización:</p>
            <p className="li-item">
              {opportunityData?.updateDate ? formatDate(opportunityData.updateDate) : ""}
            </p>
          </div>
          {opportunityData?.year != null && opportunityData?.month != null && (
            <div className="j-space-between mb-10">
              <p className="lastC-text ml-10">Mes de registro:</p>
              <p className="li-item">
                {monthsList.find((m) => m.value === opportunityData.month)?.name ?? opportunityData.month} {opportunityData.year}
              </p>
            </div>
          )}
        </div>
      </div>
      <TabComponent panels={tabData} variant="fullWidth" />
    </div>
  );
};

export default OpportunityDetails;
